export default <template>
  <div class="reviewable">
    {{outlet}}
  </div>
</template>
